'use strict';

const phone = function () {
  return function (phone) {
    return (phone && phone.code && phone.number) ? ('+' + phone.code + phone.number) : '';
  };
};

export default phone;



// WEBPACK FOOTER //
// ./app/src/filters/phone.js